import { version } from '../../package.json';
export default version;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/version/index.js
// module id = 693
// module chunks = 0